import { render, staticRenderFns } from "./CreateCostPriceRule.vue?vue&type=template&id=50ae3ebc"
import script from "./CreateCostPriceRule.vue?vue&type=script&lang=js"
export * from "./CreateCostPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports